import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';

@Component({
  selector: 'app-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss'],
})
export class DeleteModalComponent implements OnInit {
  marketrateform1: FormGroup;
  response;
  Remark;

  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    public _userService: UserManagementService,
    public dialogRef: MatDialogRef<DeleteModalComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any,
    public toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.marketrateform1 = this.fb.group({
      Remark: ['', [Validators.required]],
    });
  }
  //get f() { return this.marketrateform1.controls; }
  submit() {
    if (this.marketrateform1.valid) {
      var postdata = {
        marketRateID: this.data,
        remark: this.marketrateform1.value.Remark,
      };
      this._userService.removeMarketRate(postdata).subscribe((data) => {
        this.response = data;
        //window.location.reload();
        this.toastr.success(this.response.result.message, 'Success', {
          timeOut: 3000,
        });
      });

      this.dialogRef.close();
    } else {
      alert('Please write a valid reason');
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
